import PageNavigator from './PageNavigator';

export default PageNavigator;
